import { useCallback, useSyncExternalStore } from 'react';
import { MOBILE_QUERY, SPLIT_QUERY } from '@/styles/breakpoints';

/** Live result of a CSS media query; re-renders when it flips (resize, rotation). */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    [query],
  );
  return useSyncExternalStore(subscribe, () => window.matchMedia(query).matches);
}

/** Flutter ResponsiveUI.isMobile — see styles/breakpoints.ts for the width. */
export function useIsMobile(): boolean {
  return useMediaQuery(MOBILE_QUERY);
}

/** Desktop list/detail split (job list beside the selected job's preview). */
export function useIsSplitLayout(): boolean {
  return useMediaQuery(SPLIT_QUERY);
}
